const deviceRouters = [
  // 桩管理 - 其他
  {
    path: 'device',
    name: 'Device',
    redirect: '/manage/device/list',
    component: () => import(/* webpackChunkName: "DeviceMain" */ '@/views/device/index'),
    meta: {
      sidebar: 1,
      // 可查看桩的列表
      authKey: ['auth_device', 'auth_device_list'],
      title: 'com_sider_menu_device',
      disabled: false,
      icon: 'menu_device2',
    },
    children: [
      // 桩管理 - 列表
      {
        path: 'list',
        name: 'DeviceList',
        component: () => import(/* webpackChunkName: "DeviceList" */ '@/views/device/list'),
        meta: {
          authKey: ['auth_device', 'auth_device_list'],
          sidebar: false,
          title: 'com_sider_menu_device_list',
          breadcrumb: false,
          disabled: false,
          icon: 'menu_device',
        },
      },

      // 添加桩
      {
        path: 'add/:SN?',
        name: 'DeviceAdd',
        component: () => import(/* webpackChunkName: "DeviceAdd" */ '@/views/device/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_device_add'],
          title: 'com_sider_menu_device_add',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 更新桩
      {
        path: 'update/:id',
        name: 'DeviceUpdate',
        component: () => import(/* webpackChunkName: "DeviceUpdate" */ '@/views/device/update'),
        meta: {
          sidebar: false,
          authKey: ['auth_device_edit', 'auth_device_info'],
          title: 'com_sider_menu_device_edit',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },

      // 桩详情
      {
        path: ':listtype?/detail/:id/:type?',
        name: 'DeviceDetail',
        component: () => import(/* webpackChunkName: "DeviceDetail" */ '@/views/device/detail'),
        meta: {
          sidebar: false,
          authKey: ['auth_device_detail'],
          title: 'com_sider_menu_device_detail',
          disabled: false,
          icon: null,
          // 详情页不需要自动收集（但页面中有手动手集，因为涉及数据标题）
          autoCollect: false,
        },
      },
    ],
  },
];
export default deviceRouters;
